// src/hooks/useSyncOperatingAoiCoverage.js
//
// Reloads the per-AOI layer coverage map whenever the active operating AOI
// changes. Mirrors useSyncOperatingAoiImagery; the spec keeps the imagery
// flow untouched, so this lives as a parallel hook.

import { useEffect } from "react";
import { useOperatingAoiContext } from "../stores/useOperatingAoiContext";
import { useLayerCoverageStore } from "../stores/useLayerCoverageStore";

export function useSyncOperatingAoiCoverage() {
  const activeOperatingAoiId = useOperatingAoiContext(
    s => s.activeOperatingAoiId
  );
  const loadCoverage = useLayerCoverageStore(s => s.loadCoverage);
  const clear = useLayerCoverageStore(s => s.clear);

  useEffect(() => {
    if (activeOperatingAoiId) {
      loadCoverage(activeOperatingAoiId);
    } else {
      clear();
    }
  }, [activeOperatingAoiId, loadCoverage, clear]);
}
